import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HistoryItem } from './history-item.interface';

@Component({
    selector: 'app-history-list',
    templateUrl: './history-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class HistoryListComponent {
    @Input() public items?: HistoryItem[];

    @Input() public useTranslate = true;

    @Input() public translationPrefix = 'translate_';

    @Input() public actionTranslationPrefix = 'translate_flow_action_';
}
